export default "__VITE_ASSET__CdwFt7Aa__"